import { render, staticRenderFns } from "./ServiceCategoryListing.vue?vue&type=template&id=881b5400&scoped=true"
import script from "./ServiceCategoryListing.vue?vue&type=script&lang=js"
export * from "./ServiceCategoryListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881b5400",
  null
  
)

export default component.exports